// TODO bailey fix this
import { gql, useQuery } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { useRsvpMenu } from '@/components/EventStuff/components/RsvpMenu/hooks/useRsvpMenu';
import { ERsvpResponse } from '@/graphql-types/globalTypes';
import { useCurrent } from '@/hooks/useCurrent';

import {
  useAutoRsvp_getCurrentUserRsvp,
  useAutoRsvp_getCurrentUserRsvpVariables,
} from './graphql-types/useAutoRsvp_getCurrentUserRsvp';

const CURRENT_USER_RSVP_QUERY = gql`
  query useAutoRsvp_getCurrentUserRsvp($input: EventInput!) {
    event(input: $input) {
      eventV2 {
        ... on SimpleEventV2 {
          _id
          currentUserRsvp {
            _id
            response
          }
        }
      }
    }
  }
`;

export const useAutoRsvp = (options: { eventId: string }): void => {
  const { createRsvpForEvent } = useRsvpMenu();
  const current = useCurrent();
  const router = useRouter();
  const toast = useToast();

  const { data, loading } = useQuery<
    useAutoRsvp_getCurrentUserRsvp,
    useAutoRsvp_getCurrentUserRsvpVariables
  >(CURRENT_USER_RSVP_QUERY, {
    variables: { input: { _id: options.eventId } },
  });

  // Only automatically RSVP if the user has not already RSVP'd
  const createRsvp = React.useCallback(async () => {
    const autoRsvp = router.query.autoRsvp;
    if (
      !router.isReady ||
      !current.user?._id ||
      autoRsvp !== 'GOING' ||
      !!(
        data?.event.eventV2?.__typename === 'SimpleEventV2' &&
        data?.event.eventV2.currentUserRsvp?.response
      ) ||
      loading
    ) {
      return;
    }

    try {
      await createRsvpForEvent({
        variables: {
          input: {
            eventId: options.eventId,
            attendeeId: current.user._id,
            response: ERsvpResponse.GOING,
          },
        },
      });

      toast({
        title: `Successfully RSVP'd to this event!`,
        status: 'success',
      });
    } catch (err) {
      toast({
        title: `Failed to automatically set your RSVP`,
        status: 'error',
      });
    }
  }, [
    createRsvpForEvent,
    current.user?._id,
    data?.event.eventV2,
    loading,
    options.eventId,
    router.isReady,
    router.query.autoRsvp,
    toast,
  ]);

  React.useEffect(() => {
    createRsvp();
  }, [createRsvp]);
};
